<template>
  <div class="user_all">
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.RPC_service') }}：</span>
      <el-select
        style="width: 220px"
        v-model="selectValue"
        @change="changeRpc()"
        :placeholder="this.$t('title.RPC_service')"
      >
        <el-option
          v-for="item in options"
          :key="item.rpcUrl"
          :label="item.name"
          :value="item.rpcUrl"
        ></el-option>
      </el-select>
      <el-select
        style="margin-left: 5%;width: 220px"
        v-model="selectChain"
        @change="changeChain()"
        :placeholder="$t('title.Please_select_the_chain')"
      >
        <el-option v-for="item in options1" :key="item" :label="item+$t('title.chain')" :value="item"></el-option>
      </el-select>
      <!--            <el-button type="primary" style="margin-left: 5%" @click="searchRpc()" :loading=isResponse>查询</el-button>-->
    </div>
    <div class="user_search" style="display: flex;align-items:center;">
      <span style="width: 100px;display: inline-block">{{ $t('title.address') }}：</span>
      <el-input v-model="inputValue" type="primary" style="width: 320px" :placeholder="this.$t('title.Please_enter_the_address')"></el-input>
      <el-button type="primary" style="margin-left: 5%" @click="search" :loading="isResponse">{{ $t('title.search') }}</el-button>
      <el-button type="primary" @click="dialogVisible = true">{{ $t('title.createUser') }}</el-button>
    </div>
    <el-dialog :title="this.$t('title.title')" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      <!-- <span>用户名:</span>
      <el-input
        v-model="userName"
        type="primary"
        style="width:250px;margin-left:20px;"
        placeholder="请输入用户名"
      ></el-input> -->
      <el-form label-position="right"  label-width="100px">
        <el-form-item :label="this.$t('title.username')+':'">
          <el-input v-model="userName"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('title.Private_key_or_mnemonic')+':'">
          <el-input :placeholder="$t('title.Do_not_enter_the_default_creation_private_key')" v-model="privateKey"></el-input>
        </el-form-item>
      </el-form>
     
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('title.Cancel') }}</el-button>
        <el-button type="primary" @click="createUsers">{{ $t('title.Sure') }}</el-button>
      </span>
    </el-dialog>
    <div class="con_table">
      <el-table :data="tableData" border :header-cell-style="this.tableHeaderColor">
        <el-table-column :label="this.$t('title.Serial_number')" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.id}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.name')" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.nickname}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.RPC_service')" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.rpcServer}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Chain_id')" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.chainId}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.address')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.address}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.address)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="Nonce" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.nonce}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Balance')" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.coins}}</span>
          </template>
        </el-table-column>
        <el-table-column width="160" :label="this.$t('title.Creation_time')" align="center">
          <template slot-scope="scope">
            <span>{{timestampToTime(scope.row.createTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="this.$t('title.operate')" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">{{ $t('title.look_over') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page="currentPage"
        :page-size="pagesize"
        layout="total,prev, pager, next"
        :total="total"
      ></el-pagination>
      <el-dialog :title="this.$t('title.title')" :visible.sync="tableVisible" width="60%">
        <div class="view_detail">
          <div class="view_detail_item">
            <span>{{ $t('title.name') }}:</span>
            <span>{{this.viewObj.nickname}}</span>
          </div>
           <div class="view_detail_item">
            <span style="width:38px;">{{ $t('title.Public_key') }}:</span>
            <span>{{this.viewObj.publicKey}}</span>
          </div>
           <div class="view_detail_item">
            <span>{{ $t('title.Private_key') }}:</span>
            <span>{{this.viewObj.privateKey}}</span>
          </div>
           <div class="view_detail_item">
            <span>{{ $t('title.address') }}:</span>
            <div>
               <span>{{this.viewObj.address}}</span>
               <span>{{to_32_decimal(this.viewObj.address)}}</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="tableVisible = false">{{ $t('title.Cancel') }}</el-button>
          <el-button type="primary" @click="tableVisible = false">{{ $t('title.Sure') }} </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getrpcserver,
  getchaininfo,
  userlList,
  createUser
} from "../../../api/interface";
import { demoFunction } from "@/utils/common";
export default {
  name: "User",
  components: {},
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      isResponse: false,
      selectValue: "",
      options: "",
      selectChain: "",
      options1: "",
      inputValue: "",
      searchValue: "",
      dialogVisible: false,
      userName: "",
      privateKey: "",
      tableVisible: false,
      viewObj: {

      },
    };
  },
  methods: {
    changeRpc() {
      let data = { rpcServer: this.selectValue };
      getchaininfo(data).then(response => {
        this.options1 = response.data;
        this.selectChain = this.options1[0];
      });
    },
    changeChain() {},
    getData() {
      getrpcserver().then(response => {
        this.options = response.data;
        console.log("rpc",this.options)
        this.selectValue = this.options[0].rpcUrl;
        let data = { rpcServer: this.options[0].rpcUrl };
        getchaininfo(data).then(response => {
          this.options1 = response.data;
          console.log(this.options1, 123456);
          this.selectChain = this.options1[0];
          let data = {
            userContractId: "",
            address: "",
            page: 1,
            rows: 10
          };
          userlList(data).then(response => {
            if (response.code == 200) {
              this.tableData = response.data.data;
              console.log(this.tableData, 1111);
              this.total = response.data.total;
            } else {
              this.tableData = [];
              this.total = 0;
              this.$message.error(response.msg);
            }
          });
        });
      });
    },
    search() {
      this.currentPage = 1;
      this.isResponse = true;
      this.getTableData(this.inputValue, this.currentPage, 1);
    },
    async createUsers() {
      //助记词转为私钥
      if(this.privateKey.includes(' ')) {
        this.privateKey = await demoFunction.getPrivateKeyFromMnemonicWords(
        this.privateKey
        );
      }
      if(this.privateKey.substr(0,2) == '0x') {
        this.privateKey = this.privateKey.substr(2)
      }
      createUser({ nickname: this.userName, privateKey: this.privateKey  }).then(res => {
        this.$message.success(res.msg);
        this.getTableData(this.searchValue, this.currentPage, 0);
      })
      .catch(err => {
        this.$message.error(err.msg);
      })
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
      this.privateKey = ''
      this.userName = ''
    },
    currentPageChange(e) {
      this.currentPage = e;
      this.getTableData(this.searchValue, this.currentPage, 0);
    },
    getTableData(address, page, type) {
      let data = {
        rpcServer: this.selectValue,
        chainId: this.selectChain,
        address: address,
        page: page,
        rows: 10
      };
      userlList(data).then(response => {
        this.isResponse = false;
        if (response.code == 200) {
          this.tableData = response.data.data;
          this.total = response.data.total;
          if (type == 1) {
            this.searchValue = address;
          }
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(response.msg);
        }
      });
    },
    handleClick(val) {
      this.viewObj = val
      this.tableVisible = true
    },
  },
  computed: {
    iconColor() {
      const { color1, color2 } = this;

      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped lang="scss">
.user_all {
  padding: 20px 30px;
}

.user_search {
  margin-bottom: 30px;
}
.view_detail {
  width: 100%;
  .view_detail_item {
    display: flex;
    margin-bottom: 15px;
    align-items: center;
    span {
      display: block;
      margin-right: 20px;
    }
  }
}
</style>
